import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Thumbnail, Col, Row } from 'react-bootstrap'
import { fetchProducts } from '../actions'

import NavHeader from './navheader'
import ProductItem from './product_item'
import CategoryItem from './category_item'
import Footer from './footer'
import _ from 'lodash'

class Category extends Component {

    componentWillMount() {
        this.props.fetchProducts('s')
    }

    renderProducts() {
        let id = 1
        return _.map(this.props.products, product => {
            return (
                <ProductItem key={id++} product={product} />
            )
        })
    }

    render() {
        return (
            <div>
                <NavHeader history={this.props.history} match='categories' />
                <div className='container'>
                    <Row>
                        <CategoryItem history={this.props.history} /> <CategoryItem history={this.props.history} />
                        <CategoryItem history={this.props.history} /> <CategoryItem history={this.props.history} />
                        <CategoryItem history={this.props.history} /> <CategoryItem history={this.props.history} />
                    </Row>
                    {this.renderProducts()}
                </div>
                <Footer history={this.props.history} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        products: state.products
    }
}

export default connect(mapStateToProps, { fetchProducts })(Category)


// WEBPACK FOOTER //
// ./src/components/category.js